@let state = targetSave().attributes.content.state;

<h1>{{ state.solution_step?.chosen_idea?.idea ?? ('iackathon.no_idea' | translate) }}</h1>

<h2>
    {{ state.group_name }}
    @for (member of state.members; track member.id) {
        <span>{{ $first ? '' : ', ' }} {{ member.name }}</span>
    }
</h2>

<mat-form-field>
    <mat-select [value]="selectedGroupReviewer()" (valueChange)="onSelectedGroupReviewerChange($event)">
        <mat-option [class.active]="selectedGroupReviewer() === 'none'" [value]="'none'">{{'iackathon.all_reviews' | translate}}</mat-option>
        @for (group of groupSaves(); track group.id) {
            @let groupState = group.attributes.content.state;
            <mat-option [class.active]="selectedGroupReviewer() === group.id" [value]="group.id">
                {{ groupState.group_name }}
                @for (member of groupState.members; track member.id) {
                    <span>{{ $first ? '' : ', ' }} {{ member.name }}</span>
                }
            </mat-option>
        }
    </mat-select>
</mat-form-field>

@for (group of groupSaves(); track group.id) {
    @let groupState = group.attributes.content.state;
    @let review = groupState.groups_project_reviews[targetSaveId()];
    @if (review?.special_mark) {
        {{ review?.special_mark }}
    }
}

<table>
    <thead>
    <tr>
        <th>{{'iackathon.evaluation_by_students' | translate}}</th>
        <th>:(</th>
        <th>:|</th>
        <th>:)</th>
    </tr>
    </thead>
    <tr>
        <td>{{'iackathon.is_it_ingenuous' | translate}}</td>
        <td>{{ getReviewCount('ingenuity', 0, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('ingenuity', 1, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('ingenuity', 2, selectedGroupReviewer()) }}</td>
    </tr>
    <tr>
        <td>{{'iackathon.is_it_feasible' | translate}}</td>
        <td>{{ getReviewCount('feasibility', 0, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('feasibility', 1, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('feasibility', 2, selectedGroupReviewer()) }}</td>
    </tr>
    <tr>
        <td>{{'iackathon.would_you_use_it' | translate}}</td>
        <td>{{ getReviewCount('would_you_use_it', 0, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('would_you_use_it', 1, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('would_you_use_it', 2, selectedGroupReviewer()) }}</td>
    </tr>
</table>

<div>

    {{'iackathon.some_comments' | translate}}

    @if (selectedGroupReviewer() === 'none') {
        <button (click)="onChangeIndexClick(commentGroupIndex,-1)"><</button>
        {{ commentGroupIndex() + 1 }}/{{ groupSaves().length }}
        <button (click)="onChangeIndexClick(commentGroupIndex,1)">></button>
    }

    @for (group of groupSaves(); track group.id) {
        @if (selectedGroupReviewer() === 'none' || selectedGroupReviewer() === group.id) {
            @let groupState = group.attributes.content.state;
            @let review = groupState.groups_project_reviews[targetSaveId()];
            @if (commentGroupIndex() === $index) {
                {{ groupState.group_name }}
                @for (member of groupState.members; track member.id) {
                    <span>{{ $first ? '' : ', ' }} {{ member.name }}</span>
                }
                <p>"{{ review?.comments }}"</p>
            }
        }
    }

</div>

<table>
    <thead>
    <tr>
        <th>{{'iackathon.evaluation_by_students' | translate}}</th>
        <th>:(</th>
        <th>:|</th>
        <th>:)</th>
    </tr>
    </thead>
    <tr>
        <td>{{'iackathon.long_time_impact' | translate}}</td>
        <td>{{ getReviewCount('long_time_impact', 0, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('long_time_impact', 1, selectedGroupReviewer()) }}</td>
        <td>{{ getReviewCount('long_time_impact', 2, selectedGroupReviewer()) }}</td>
    </tr>
</table>

<div>
    {{'iackathon.what_would_you_do_differently' | translate}}

    @if (selectedGroupReviewer() === 'none') {
        <button (click)="onChangeIndexClick(anotherWayGroupIndex,-1)"><</button>
        {{ anotherWayGroupIndex() + 1 }}/{{ groupSaves().length }}
        <button (click)="onChangeIndexClick(anotherWayGroupIndex,1)">></button>
    }

    @for (group of groupSaves(); track group.id) {
        @if (selectedGroupReviewer() === 'none' || selectedGroupReviewer() === group.id) {
            @let groupState = group.attributes.content.state;
            @let review = groupState.groups_project_reviews[targetSaveId()];

            @if (anotherWayGroupIndex() === $index) {
                {{ groupState.group_name }}
                @for (member of groupState.members; track member.id) {
                    <span>{{ $first ? '' : ', ' }} {{ member.name }}</span>
                }
                <p>"{{ review?.how_make_it_another_way }}"</p>
            }
        }
    }

</div>
